import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { motion } from 'framer-motion';
import { Anchor, Zap, Trophy, Timer, Waves, Sunrise } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function SurfskiPage() {
  useEffect(() => {
    // Set meta tags for Surfski page
    document.title = "קיאק Surfski | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'חתירה בקיאק Surfski בכנרת - מהירות, אדרנלין וטכניקה או חתירה רגועה ונופי הכנרת. הדרכות וקבוצות אימון');
    // Open Graph tags with image
    const ogTags = [{
      property: 'og:title',
      content: "קיאק Surfski | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'חתירה בקיאק Surfski בכנרת - מהירות ואדרנלין או חתירה רגועה. הדרכות אישיות וקבוצות אימון'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7vRPckyZqmqZUztC54T3ts/image_%287%29.png'
    }, {
      property: 'og:image:width',
      content: '1200'
    }, {
      property: 'og:image:height',
      content: '630'
    }, {
      property: 'og:url',
      content: window.location.href
    },
    // Twitter Card tags
    {
      property: 'twitter:card',
      content: 'summary_large_image'
    }, {
      property: 'twitter:title',
      content: "קיאק Surfski | ביץ' קלאב מעגן"
    }, {
      property: 'twitter:description',
      content: 'חתירה בקיאק Surfski בכנרת - מהירות ואדרנלין'
    }, {
      property: 'twitter:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7vRPckyZqmqZUztC54T3ts/image_%287%29.png'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-1136">
      <Navigation data-id="element-1137" />

      {/* Hero Section */}
      <div className="relative h-[60vh] overflow-hidden" data-id="element-1138">
        <div className="absolute inset-0 bg-black/40 z-10" data-id="element-1139" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7vRPckyZqmqZUztC54T3ts/image_%287%29.png" alt="Surfski Activity" className="w-full h-full object-cover" data-id="element-1140" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-1141">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-bold mb-4" data-id="element-1142">
            קיאק Surfski
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl max-w-2xl font-light" data-id="element-1143">
            מהירות, אדרנלין וטכניקה על המים - או סתם חתירה רגועה ונופי הכנרת
          </motion.p>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-1144">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-1145">
          <div data-id="element-1146">
            <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6" data-id="element-1147">
              על הפעילות
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-1148">
              ה-Surfski הוא קיאק פתוח, צר וארוך, המיועד לחתירה מהירה ולגלישת
              גלים (Downwind). זהו ספורט המשלב כושר גופני אירובי ברמה גבוהה עם
              מיומנות טכנית של קריאת הים ותפיסת גלים. במועדון שלנו תמצאו את
              הקיאקים הטובים בעולם מבית המותגים המובילים.
            </p>

            {/* Relaxed Paddling Section */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-100 rounded-2xl p-6 mb-8" data-id="element-1149">
              <div className="flex items-start gap-4" data-id="element-1150">
                <div className="bg-white p-3 rounded-xl shadow-sm" data-id="element-1151">
                  <Sunrise className="w-6 h-6 text-blue-500" data-id="element-1152" />
                </div>
                <div data-id="element-1153">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1154">
                    חתירה רגועה ונופי הכנרת
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-1155">
                    לא חייבים להיות ספורטיביים! הקיאק מושלם גם לחתירה רגועה
                    ונינוחה על מי הכנרת השקטים. תיהנו מהשקט, מהנוף המדהים של
                    ההרים מסביב, ומחוויה מדיטטיבית של חיבור לטבע. מתאים במיוחד
                    לזריחות ושקיעות קסומות.
                  </p>
                </div>
              </div>
            </motion.div>

            <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-1156">
              למי זה מתאים?
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-1157">
              {['חותרים המחפשים אתגר פיזי ומנטלי', 'אוהבי אדרנלין ומהירות', 'מי שרוצה חתירה רגועה ולהנות מנופי הכנרת', 'מי שרק בא לו להרגע ולהתנתק מהשגרה', 'אנשים עם רקע בחתירה (אך לא חובה, יש קורסי מתחילים)', 'מי שרוצה לשפר את הכושר האירובי בצורה משמעותית'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-1158">
                  <div className="bg-indigo-100 p-1 rounded-full" data-id="element-1159">
                    <Zap className="w-4 h-4 text-indigo-600" data-id="element-1160" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-1161">
            <h3 className="text-2xl font-bold text-[#0A5F8F] mb-6" data-id="element-1162">
              מה אנחנו מציעים?
            </h3>

            <div className="space-y-6" data-id="element-1163">
              <div className="flex gap-4" data-id="element-1164">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1165">
                  <Anchor className="w-6 h-6 text-indigo-500" data-id="element-1166" />
                </div>
                <div data-id="element-1167">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1168">
                    הדרכות אישיות ברמות שונות
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1169">
                    ליווי אישי מותאם לרמתך - ממתחילים מוחלטים ועד חותרים
                    מתקדמים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1170">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1171">
                  <Waves className="w-6 h-6 text-indigo-500" data-id="element-1172" />
                </div>
                <div data-id="element-1173">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1174">הדרכות קבוצתיות</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1175">
                    אימונים קבוצתיים באווירה תומכת ומעצימה, מחולקים לפי רמות.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1176">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1177">
                  <Zap className="w-6 h-6 text-indigo-500" data-id="element-1178" />
                </div>
                <div data-id="element-1179">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1180">קהילה שוקקת</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1181">
                    הצטרפו לקהילת חותרים פעילה ומגובשת שחולקת את אהבת המים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1182">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1183">
                  <Trophy className="w-6 h-6 text-indigo-500" data-id="element-1184" />
                </div>
                <div data-id="element-1185">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1186">
                    אירועי חתירה ספורטיביים
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1187">
                    חתירות וטיולים חוויתיים, שקיעה וזריחה, חציית הכנרת ועוד
                    מפגשים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1188">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1189">
                  <Timer className="w-6 h-6 text-indigo-500" data-id="element-1190" />
                </div>
                <div data-id="element-1191">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1192">אחסנת ציוד אישי</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1193">
                    אפשרות לאחסון הציוד האישי שלכם במועדון בנוחות ובבטחה.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1194">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1195">
                  <Waves className="w-6 h-6 text-indigo-500" data-id="element-1196" />
                </div>
                <div data-id="element-1197">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1198">
                    שימוש חופשי בציוד המועדון
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1199">
                    חברי המועדון נהנים משימוש חופשי בציוד החתירה החדיש והאיכותי
                    של המועדון לחתירות עצמאיות.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-1200">
              <Button className="w-full text-lg py-6" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-1201">
                הצטרפו לאימון ניסיון
              </Button>
            </div>
          </div>
        </div>
      </div>

      <ContactSection data-id="element-1202" />
      <Footer data-id="element-1203" />
    </div>;
}